module.exports = require('./generateContextHOC')
